import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
      {categories.map((cat) => (
        <a
          key={cat.key}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-400"
        >
          <div className="relative h-24 w-full overflow-hidden md:h-28">
            <img
              src={cat.image}
              alt={t(cat.key)}
              title={`${t(cat.key)} — USFans Spreadsheet`}
              className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
            />
          </div>
          <div className="flex items-center justify-between gap-2 px-3 py-3">
            <span className="flex min-w-0 items-center gap-2">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-background-100 text-foreground-600 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-base`} />
              </span>
              <span className="truncate whitespace-nowrap text-sm font-medium text-foreground-900">
                {t(cat.key)}
              </span>
            </span>
            <i className="ri-arrow-right-up-line w-4 h-4 shrink-0 flex items-center justify-center text-base text-foreground-400 transition-colors group-hover:text-primary-600" />
          </div>
        </a>
      ))}
    </div>
  );
}